import { render } from "./App.vue?vue&type=template&id=cc476c34"
const script = {}

import "./stylesheets/Common.css?vue&type=style&index=0&lang=css"
import "./stylesheets/Box.css?vue&type=style&index=1&lang=css"
import "./stylesheets/InlineText.css?vue&type=style&index=2&lang=css"
import "./stylesheets/Table.css?vue&type=style&index=3&lang=css"
import "./stylesheets/Form.css?vue&type=style&index=4&lang=css"
import "./stylesheets/List.css?vue&type=style&index=5&lang=css"

import exportComponent from "/codebuild/output/src834291806/src/oms-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__